import { GET_PATIENTS_SUCCESS } from "./patients.types";

const initialState = {
  patientsList: null,
};

export const patientsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PATIENTS_SUCCESS:
      return {
        ...state,
        patientsList: action.payload,
      };

    default:
      return state;
  }
};
